import service from "../service";

export const getEmailReportsService = () => (
  service('post', `v3/reportes/correo`)
)

export const createEmailReportService = (data) => (
  service('put', `v3/reportes/correo`, { data })
)

export const updateEmailReportService = (reportId, data) => (
  service('patch', `v3/reportes/correo/${reportId}`, { data })
)

export const removeEmailReportService = (reportId) => (
  service('delete', `v3/reportes/correo/${reportId}`)
)

export const sendEmailReportService = (reportId) => (
  service('get', `v3/reportes/correo/${reportId}/enviar`)
)

export const getEmailReportHistoryService = (reportId) => (
  service('get', `v3/reportes/correo/${reportId}/historial`)
)

export const getEmailReportHistoryGlobalService = () => (
  service('get', `v3/reportes/correo/historial`)
)

